module.exports = __webpack_public_path__ + "static/media/read_more.982c711f.svg";